export function formatGuideObservations(
  guides: any[],
  type: 'PROCEDIMENTO' | 'OPME',
  onlyDivergent = false
): string {
  if (!guides || !Array.isArray(guides)) {
    return ''
  }

  const formattedItems: string[] = []

  guides.forEach((guide) => {
    if (guide?.items && Array.isArray(guide.items)) {
      guide.items.forEach((item: any) => {
        if (
          onlyDivergent &&
          Number(item?.quantity_authorized) === Number(item?.quantity)
        ) {
          return
        }

        const description = item?.description?.trim()
        const observation = item?.observation?.trim()

        let itemText = ''

        if (description) {
          itemText += `${type}: ${description}`
        }

        if (itemText) {
          itemText += `\nOBSERVAÇÃO: ${observation || ''}`
        } else if (observation) {
          itemText = `OBSERVAÇÃO: ${observation}`
        }

        if (itemText) {
          formattedItems.push(itemText)
        }
      })
    }
  })
  return formattedItems.join('\n\n')
}
